/* eslint no-underscore-dangle:0 */

export const SortNumeric = (a, b) => {
  const x = Number(a);
  const y = Number(b);

  if (x < y) {
    return -1;
  }

  if (x > y) {
    return 1;
  }

  return 0;
};

export const sortPlatforms = (a, b) => {
  if (a !== undefined && b !== undefined) {
    const x = a.PlatformName;
    const y = b.PlatformName;
    if (x < y) {
      return -1;
    }

    if (x > y) {
      return 1;
    }
  }

  return 0;
};

export const isNumber = val => {
  const pattern = /^\s*\d+\s*$/;
  return String(val).search(pattern) !== -1;
};

export const GetSearchWordsAsArray = searchText => {
  const pattern = /\w+/g;
  return searchText.match(pattern);
};

export const MapSearchTermtoExpectedStreetTypes = thisTerm => {
  let mappedStreetType = "";
  const str = thisTerm.toLowerCase();
  if (str === "avenue") mappedStreetType = "ave";
  else if (str === "crescent") mappedStreetType = "cres";
  else if (str === "drive") mappedStreetType = "dr";
  else if (str === "parade") mappedStreetType = "pde";
  else if (str === "place") mappedStreetType = "pl";
  else if (str === "quay") mappedStreetType = "qy";
  else if (str === "road") mappedStreetType = "rd";
  else if (str === "street") mappedStreetType = "st";
  return mappedStreetType;
};

export const DeriveJPProxyQueryString = jpUrl => {
  const internalProxyUrl = "http://proxy:8080";
  let qs = jpUrl.replace(/\?/g, "%3F").replace(/&/g, "%26"); // escape(jpUrl).replace(/\//g, "%2F");
  if (internalProxyUrl && internalProxyUrl !== "")
    qs = `${qs}&proxy=${internalProxyUrl}&cred=true`;
  return qs;
};

export const AppendSearchOption = (url, qskey, qsval) => {
  let newUrl = url;
  if (newUrl.indexOf("?") < 0) newUrl += "?";
  else newUrl += "&";
  return `${newUrl + qskey}=${qsval.replace(" ", "+")}`;
};

const flatRoute = (route, destination, trip) => ({
  ID: `${route._attributes.RouteNo}${trip._attributes.ETA}`,
  RouteNo: route._attributes.RouteNo,
  RouteName: route._attributes.Name,
  Name: destination._attributes.Name,
  ETA: trip._attributes.ETA,
  TripNo: trip._attributes.TripNo,
  WheelchairAccess: trip._attributes.WheelchairAccess
});

export const flattenTrip = (route, destination, flatRoutes) => {
  if (Array.isArray(destination.Trip)) {
    destination.Trip.map(trip =>
      flatRoutes.push(flatRoute(route, destination, trip))
    );
  } else {
    flatRoutes.push(flatRoute(route, destination, destination.Trip));
  }

  return flatRoutes;
};

export const flattenRoutes = routes => {
  let flatRoutes = [];

  if (Array.isArray(routes)) {
    routes.map(route => {
      if (Array.isArray(route.Destination)) {
        return route.Destination.map(destination => {
          flatRoutes = flattenTrip(route, destination, flatRoutes);
          return flatRoutes;
        });
      }

      flatRoutes = flattenTrip(route, route.Destination, flatRoutes);
      return flatRoutes;
    });
  } else if (Array.isArray(routes.Destination)) {
    routes.Destination.map(d => flattenTrip(routes, d, flatRoutes));
  } else {
    flatRoutes = flattenTrip(routes, routes.Destination, flatRoutes);
  }

  return flatRoutes;
};

export const orientation = bearing => {
  if (bearing >= 45 && bearing < 135) {
    return "North";
  }

  if (bearing >= 135 && bearing < 225) {
    return "East";
  }

  if (bearing >= 225 && bearing < 315) {
    return "South";
  }

  return "West";
};

export const sortRouteNo = routeNos => {
  let routeNumbers = "";
  let routesArray = [];
  if (routeNos && routeNos.length > 0) {
    routesArray = routeNos.split("|");
    routesArray.sort(SortNumeric);
    routeNumbers = routesArray.join(", ");
  }

  return routeNumbers;
};

export const capitalize = string =>
  string.replace(/(?:^|\s)\S/g, a => a.toUpperCase());

export const wrap = (el, wrapper) => {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
};

export const ResponsiveTables = () => {
  const init = () => {
    const tables = [].slice.call(document.getElementsByTagName("table"));

    // init them
    tables.forEach(el => {
      const wrapper = document.createElement("div");
      wrapper.classList.add("overflow-x-auto");

      wrap(el, wrapper);
    });
  };

  init();
};

export const getParam = param => {
  const regexp = new RegExp(`[?&]${param}=([^&]*)`);
  const res = regexp.exec(window.location.search);
  return res === null ? "" : decodeURIComponent(res[1]);
};
